import {Router} from '@angular/router';

/**
 * Make sure to call this from the constructor and not ngOnInit because the scope ends after the constructor
 */
export function getStateFromRouter(router: Router): any {
  return router?.getCurrentNavigation()?.extras?.state;
}
